import { render, staticRenderFns } from "./LinhaProdutoList.vue?vue&type=template&id=61ec2aab&scoped=true"
import script from "./LinhaProdutoList.vue?vue&type=script&lang=js"
export * from "./LinhaProdutoList.vue?vue&type=script&lang=js"
import style0 from "./LinhaProdutoList.vue?vue&type=style&index=0&id=61ec2aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec2aab",
  null
  
)

export default component.exports